import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const PdfEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="PDF Editor for Android — Edit, Merge & Sign PDFs on Your Phone | Cosmovex"
    metaDescription="PDF Toolkit AI for Android. Edit, merge, split, compress, and sign PDF files on your phone. AI document assistant for summaries and Q&A. No cloud upload required."
    ogTitle="PDF Editor for Android — PDF Toolkit AI"
    h1="PDF Editor for Android"
    intro="A complete PDF toolkit in your pocket. Merge, split, compress, sign, and annotate PDFs without a computer. AI-powered document summarization and Q&A built-in."
    paragraphs={[
      "Handling PDFs on mobile is usually a pain — you need separate apps for viewing, editing, signing, and converting. PDF Toolkit AI rolls everything into one app. Whether you're reviewing a contract, signing a document, combining reports, or extracting data, you don't need to switch apps or touch a desktop.",
      "Merge multiple PDFs into one seamless document. Split a large PDF into individual pages. Compress PDFs to make them smaller for email or cloud storage. Convert PDFs to Word, images, or text without losing formatting. All editing operations happen on-device — no cloud upload, no slow servers, just instant results.",
      "The built-in AI assistant understands your PDFs. Ask questions about document content, get instant summaries, extract key information, and find specific pages in seconds. It's like having a research assistant for any PDF. Sign documents digitally with your finger or a typed signature, add highlights, comments, and annotations.",
      "Core PDF operations work completely offline. AI features (summarize, Q&A) need internet to connect to Gemini AI, but everything else stays private on your device. Perfect for business users, lawyers, students, and anyone who deals with PDF documents regularly.",
    ]}
    features={[
      "Merge multiple PDFs into one",
      "Split PDFs into individual pages",
      "Compress PDFs for sharing",
      "AI document summarization",
      "AI question & answer on PDF content",
      "Digital signature support",
      "Annotate with highlights and comments",
      "Convert PDF to Word, JPG, PNG, text",
      "Convert Word and images to PDF",
      "Works offline for core features",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.pdftoolkitai"
    icon="/images/pdftoolkitai.png"
    appName="PDF Toolkit AI"
    accentColor="#A8720E"
    canonicalPath="/pdf-editor-android"
  />
);

export default PdfEditorAndroid;
